import React from 'react';
import { 
  Package2, // For Flat Bottom Design
  Box, // For Pre-Creased Opening
  Shield, // For Durable Material
  Leaf, // For Eco-Friendly
  Palette, // For Customizable Surface
  Store // For Versatile Applications
} from 'lucide-react';
  
  const ProductCategory1 = () => {
    const leftFeatures = [
      {
        icon: <Package2 size={40} />,
        title: "Square Bottom Design",
        description: "A sturdy, square base ensures stability, allowing the bag to stand upright for effortless packing.",
        isYellow: false
      },
      {
        icon: <Box size={40} />,
        title: "Pre-Creased Opening",
        description: "Designed with pre-creased folds, these bags open instantly, saving time and ensuring convenience for users",
        isYellow: true
      },
      {
        icon: <Shield size={40} />,
        title: "Durable Kraft Paper",
        description: "Constructed with premium kraft paper, they resist tears and can carry both light and heavy items.",
        isYellow: false
      },
    ];
  
    const rightFeatures = [
      {
        icon: <Leaf size={40} />,
        title: "Eco-Friendly Material",
        description: "100% recyclable and biodegradable, these bags cater to businesses",
        isYellow: true
      },
      {
        icon: <Palette size={40} />,
        title: "Customizable Surface",
        description: "The smooth exterior offers a perfect canvas for logos and designs, enhancing brand visibility.",
        isYellow: false
      },
      {
        icon: <Store size={40} />,
        title: "Versatile Applications",
        description: "Ideal for groceries, takeout, retail, and bakery items, meeting a wide variety of business needs.",
        isYellow: true
      }
    ];

    const Feature = ({ icon, title, description, isYellow }) => (
      <div className="d-flex align-items-start mb-4 feature-item">
        <div className={`rounded-circle p-3 ${isYellow ? 'bg-warning bg-opacity-10' : 'bg-success bg-opacity-10'}`}>
          {icon}
        </div>
        <div className="ms-3">
          <h3 className="h6 fw-bold mb-2">{title}</h3>
          <p className="small text-muted mb-0">{description}</p>
        </div>
      </div>
    );
    
    return (
      <div className="container py-5">
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-lg-8 text-center">
            <h2 className="display-6 fw-bold mb-3">Self Opening Square Paper Bags Premium Details</h2>
            <p className="text-muted mb-0">
            Self-Opening Square Paper Bags are designed with a sturdy flat base and pre-creased folds, ensuring easy use, durability, and versatility for various packaging needs.     
            </p>
          </div>
        </div>
    
        <div className="row align-items-center gy-5">
          {/* Left Features */}
          <div className="col-12 col-md-4">
            <div className="pe-md-4">
              {leftFeatures.map((feature, index) => (
                <Feature key={index} {...feature} />
              ))}
            </div>
          </div>
    
          {/* Center Image */}
        <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
        <div className="position-relative image-container">
          <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto" 
               style={{ 
                 width: '350px',
                 height: '350px',
                 maxWidth: '100%',
                 overflow: 'hidden'
               }}>
                <img
                  src="/assets/products-circle-images/sos-cicular-bag.png"
                  alt="SOS-Paper-Bag"
                  className="img-fluid product-zoom-image"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>

      {/* Right Features */}
      <div className="col-12 col-md-4">
        <div className="ps-md-4">
          {rightFeatures.map((feature, index) => (
            <Feature key={index} {...feature} />
          ))}
        </div>
      </div>
    </div>

    <style jsx>{`
      .feature-item {
        transition: transform 0.3s ease;
      }
      .feature-item:hover {
        transform: translateY(-5px);
      }
      
      /* Large Zoom Effect for Product Image */
      .image-container {
        cursor: pointer;
      }
      
      .product-zoom-image {
        transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transform-origin: center center;
      }
      
      .image-container:hover .product-zoom-image {
        transform: scale(1.8);
      }
      
      @media (max-width: 768px) {
        .feature-item {
          margin-bottom: 1.5rem;
        }
        .h6 {
          font-size: 1rem;
        }
        .small {
          font-size: 0.875rem;
        }
        .rounded-circle {
          padding: 0.75rem !important;
        }
        .container {
          padding-left: 15px;
          padding-right: 15px;
        }
        .pe-md-4, .ps-md-4 {
          padding: 0 15px;
        }
        .row {
          margin-left: -15px;
          margin-right: -15px;
        }
        
        /* Adjust zoom effect for mobile */
        .image-container:hover .product-zoom-image {
          transform: scale(1.5);
        }
      }
    `}</style>
      </div>
    );
    };
    
    export default ProductCategory1;